import { CleaningFrequency } from "Types";

export const CleaningFrequencySelectOptions = [
  { label: "Unknown", value: CleaningFrequency.UNKNOWN },
  { label: "One Time", value: CleaningFrequency.ONETIME },
  { label: "Weekly", value: CleaningFrequency.WEEKLY },
  { label: "Bi-weekly", value: CleaningFrequency.BIWEEKLY },
  { label: "Monthly", value: CleaningFrequency.MONTHLY },
];
